module.exports = __webpack_public_path__ + "img/cabinet_off.52be08cd.svg";